require('./helpers/bundle-manifest').register(JSON.parse("{\"5Q1ga\":\"main.js\",\"fTta9\":\"favicon.png\",\"8ZeQm\":\"main.css\"}"));